export const initalPageSize = 10;

export const initalPage = 1;
